<template>
  <div class="modal whats-new animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('whats_new_modal.whats_new') }}</p>
      </header>
      <section class="modal-card-body">
        <p>{{ $t('whats_new_modal.default_message') }}</p>
      </section>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Events: window.Events
    }
  },
  methods: {
    closeModal() {
      this.Events.$emit('modalClose', 'whatsNewModal');
    }
  }
}
</script>

<style lang="scss" scoped>
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}

.modal-card-body {
  p {
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// whats-new-modal.vue?7c78f84e